import { render, staticRenderFns } from "./FaceDrawer.vue?vue&type=template&id=3109eeb0&scoped=true&"
import script from "./FaceDrawer.vue?vue&type=script&lang=js&"
export * from "./FaceDrawer.vue?vue&type=script&lang=js&"
import style0 from "./FaceDrawer.vue?vue&type=style&index=0&id=3109eeb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3109eeb0",
  null
  
)

export default component.exports